import Header from "./components/Header.js";

import Content from "./components/content";

import About from "./components/about";

import Contact from "./components/Contact";

function App() {

  return (

    <div className="App">

      <Header />

      <Content />

      <About />

      <Contact />

    </div>

  );

}

 

export default App;